import { render, staticRenderFns } from "./PassoFaltaPouco.vue?vue&type=template&id=4e2bcbe2"
import script from "./PassoFaltaPouco.vue?vue&type=script&lang=js"
export * from "./PassoFaltaPouco.vue?vue&type=script&lang=js"
import style0 from "./PassoFaltaPouco.vue?vue&type=style&index=0&id=4e2bcbe2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VCheckbox,VCol,VForm,VRow})
